// extracted by mini-css-extract-plugin
export default {"section":"Terms_section__gmfV5","chapter":"Terms_chapter__Udk0f","special":"Terms_special__rgmJ2"};